import _ from 'lodash';

export const dayOfWeek = [
  { value: 'MON', label: 'Monday' },
  { value: 'TUE', label: 'Tuesday' },
  { value: 'WED', label: 'Wednesday' },
  { value: 'THU', label: 'Thursday' },
  { value: 'FRI', label: 'Friday' },
  { value: 'SAT', label: 'Saturday' },
  { value: 'SUN', label: 'Sunday' },
];

export const HOLIDAYS = [
  {
    id: 1,
    label: "New Year's Day: January 1",
    days: ['2024-01-01', '2025-01-01', '2026-01-01', '2027-01-01', '2028-01-01', '2029-01-01', '2030-01-01'],
  },
  {
    id: 2,
    label: 'Memorial Day: Last Monday of May',
    days: ['2024-05-27', '2025-05-26', '2026-05-25', '2027-05-31', '2028-05-29', '2029-05-28', '2030-05-27'],
  },
  {
    id: 3,
    label: 'Independence Day: July 4',
    days: ['2024-07-04', '2025-07-04', '2026-07-04', '2027-07-04', '2028-07-04', '2029-07-04', '2030-07-04'],
  },
  {
    id: 4,
    label: 'Labor Day: First Monday of September',
    days: ['2024-09-02', '2025-09-01', '2026-09-07', '2027-09-06', '2028-09-04', '2029-09-03', '2030-09-02'],
  },
  {
    id: 5,
    label: 'Thanksgiving Day: Fourth Thursday of November',
    days: ['2024-11-28', '2025-11-27', '2026-11-26', '2027-11-25', '2028-11-23', '2029-11-22', '2030-11-28'],
  },
  {
    id: 6,
    label: 'Christmas Day: December 25',
    days: ['2024-12-25', '2025-12-25', '2026-12-25', '2027-12-25', '2028-12-25', '2029-12-25', '2030-12-25'],
  },
];

export const HOLIDAY_YEARS = _.map(HOLIDAYS[0].days, (date) => date.split('-')[0]);
